export default __webpack_public_path__ + "static/media/automatization.b3dd78d6.svg";